import { render, staticRenderFns } from "./ChooseAttributesModal.vue?vue&type=template&id=2d631b86&scoped=true"
import script from "./ChooseAttributesModal.vue?vue&type=script&lang=js"
export * from "./ChooseAttributesModal.vue?vue&type=script&lang=js"
import style0 from "./ChooseAttributesModal.vue?vue&type=style&index=0&id=2d631b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d631b86",
  null
  
)

export default component.exports